import React from 'react'
import { useAuth } from '../../hooks/useAuth'

export default function RocketWall() {

    const { user } = useAuth();
  return (
    <iframe width="100%" height="1000px" title="RocketWall Offer Wall" allow="clipboard-write" src={`https://offerwall.rewardrocket.app/1/${user.id}`}/>
  )
}